import { useState } from 'react';
import { useCriarSocio } from '../../hooks';
import type { UsuarioOut } from '../../types';

interface Props {
  usuarios: UsuarioOut[];
  onPronto?: () => void;
}

const inp = 'text-sm border border-gray-300 dark:border-gray-600 rounded px-2 py-1.5 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-400';

export function FormSocio({ usuarios, onPronto }: Props) {
  const [nome, setNome] = useState('');
  const [pctC, setPctC] = useState(0);
  const [pctS, setPctS] = useState(0);
  const [usuarioId, setUsuarioId] = useState<number | ''>('');
  const [erro, setErro] = useState<string | null>(null);
  const criar = useCriarSocio();

  async function adicionar() {
    if (!nome.trim()) return;
    setErro(null);
    try {
      await criar.mutateAsync({
        nome: nome.trim(),
        pct_contratuais: pctC,
        pct_sucumbencia: pctS,
        usuario_id: usuarioId === '' ? null : Number(usuarioId),
        ativo: true,
      });
      setNome(''); setPctC(0); setPctS(0); setUsuarioId('');
      onPronto?.();
    } catch (e: any) {
      setErro(e?.message ?? 'Erro ao adicionar o sócio.');
    }
  }

  return (
    <div className="rounded-lg border border-dashed border-gray-300 dark:border-gray-600 p-3 space-y-2">
      <div className="grid grid-cols-1 sm:grid-cols-[1fr_5rem_5rem_1fr_auto] gap-2 items-end">
        <div>
          <label className="block text-[11px] text-gray-500 dark:text-gray-400 mb-0.5">Nome do sócio</label>
          <input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome" className={`${inp} w-full`} />
        </div>
        <div>
          <label className="block text-[11px] text-gray-500 dark:text-gray-400 mb-0.5">% contrat.</label>
          <input type="number" min={0} max={100} step="0.01" value={pctC} onChange={(e) => setPctC(parseFloat(e.target.value) || 0)} className={`${inp} w-full text-right tabular-nums`} />
        </div>
        <div>
          <label className="block text-[11px] text-gray-500 dark:text-gray-400 mb-0.5">% sucumb.</label>
          <input type="number" min={0} max={100} step="0.01" value={pctS} onChange={(e) => setPctS(parseFloat(e.target.value) || 0)} className={`${inp} w-full text-right tabular-nums`} />
        </div>
        <div>
          <label className="block text-[11px] text-gray-500 dark:text-gray-400 mb-0.5">Usuário (opcional)</label>
          <select value={usuarioId} onChange={(e) => setUsuarioId(e.target.value === '' ? '' : Number(e.target.value))} className={`${inp} w-full`}>
            <option value="">—</option>
            {usuarios.map((u) => <option key={u.id} value={u.id}>{u.nome}</option>)}
          </select>
        </div>
        <button type="button" onClick={adicionar} disabled={!nome.trim() || criar.isPending}
          className="px-3 py-1.5 text-sm rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-40">
          + Adicionar
        </button>
      </div>
      {erro && <p className="text-[11px] text-rose-600 dark:text-rose-400">{erro}</p>}
    </div>
  );
}
